module.exports = __webpack_public_path__ + "img/CA.4bed61d0.svg";